import '@/styles/globals.css'

// Every rich text body from the CMS is styled in this one stylesheet.
import '@/styles/rich-text.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { Plus_Jakarta_Sans, DM_Mono } from 'next/font/google'

const sans = Plus_Jakarta_Sans({
    subsets: ['latin']
})

const mono = DM_Mono({
    subsets: ['latin'],
    weight: ['400', '500']
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${mono.style.fontFamily};--font-app-heading:${sans.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='h-full font-sans'>
            <Head>
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
            </Head>

            <Component {...pageProps} />
        </div>
    )
}

export default App
